import request from '../../../Helpers/Request';

class Categories {
    constructor(settings) {
        this.settings = settings;
    }

    getItemsFromWebshop(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/brands`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    getItemsFromFeed(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/brands/feed`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    getCombined(id) {
        return new Promise((resolve, reject) => {
            request('GET', `/clients/connections/${id}/brands/index`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    update(id, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/connections/${id}/brands/update`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    updateItemInWebshop(connectionId, brandId, data) {
        return new Promise((resolve, reject) => {
            request('PUT', `/clients/connections/${connectionId}/brands/webshops/${brandId}`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    createItemsInWebshop(id, data) {
        return new Promise((resolve, reject) => {
            request('POST', `/clients/connections/${id}/brands/webshops`, this.settings, data)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    deleteItemInWebshop(connectionId, brandId) {
        return new Promise((resolve, reject) => {
            request('DELETE', `/clients/connections/${connectionId}/brands/webshops/${brandId}`, this.settings)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        });
    }
}

export default Categories;
